module.exports = __webpack_public_path__ + "static/media/Ice_Bucket.92f422a7.svg";